module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-17.25d08c60.jpg";